<template lang="pug">
div.list-group-gap
    div.box.list-group-item.p-a-0(v-for="settings in sortGroupedSettings(groupedSettings)")
        div.box-header.b-b
            h3 {{ settings[0].group.name }}
            small(v-if="settings[0].group.description != null") {{ settings[0].group.description }}

        div.box-body
            form-input(
                v-for="setting in sortSettings(settings)"
                :validator="validator",
                :setting="setting",
                :key="setting.id"
            )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import formInput from './central-setting-form-input.vue';

export default {
    components: { formInput },

    props: {
        validator: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters('centralSettings', ['groupedSettings']),

        sortGroupedSettings: () => settings => {
            return _.orderBy(settings, e => e[0].group.sequence);
        },

        sortSettings: () => settings => {
            return _.sortBy(settings, ['sequence']);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables';

.list-group-gap {
    .list-group-item {
        &:first-child,
        &:last-child {
            border-color: $input-border-color;
            box-shadow: 0 0 0;
        }

        &.invalid {
            border-color: $error-color;
        }
    }
}

.list-group-item {
    border-color: $input-border-color;
    box-shadow: 0 0 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-setting-form-container.vue